import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'df-public-tactic-manage',
  templateUrl: './public-tactic-manage.component.html',
  styleUrls: ['./public-tactic-manage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicTacticManageComponent {}
